import { useState, useEffect } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import React from 'react'
import { Schema, Form } from 'rsuite';
import RedStar from '../../../../../Shared/GenericComponents/RedStar'


function AddEditRecommendationModal(props) {
    const [recommendationModel, setRecommendationModel] = useState(
        {
            applicationId: 0,
            dateCrte: null,
            deleted: false,
            email: "",
            entityId: 0,
            id: 0,
            firstName: "",
            lastName: "",
            userCrte: "",
            verificationStatus: null,
            modalType: "Add"
        })
    const [showErrors, setShowErrors] = useState(false);

    useEffect(() => {
        setRecommendationModel(props.modaldata);
    }, [props.modaldata])

    const { StringType } = Schema.Types;
    const model = Schema.Model({
        firstName: StringType().isRequired("This field is required."),
        lastName: StringType().isRequired('This field is required.'),
        email: StringType().isRequired('This field is required.').isEmail('Enter in a valid Email')
    })

    const submitData = (validation, event) => {
        if (validation) {
            var dataToTransmit = {
                ...recommendationModel,
                id: recommendationModel.id === '' ? 0 : recommendationModel.id,
                dateCrte: new Date()
            };
            delete dataToTransmit.modalType;
            props.onsave(dataToTransmit).then((response) => {
                if (response.data.id) {
                    props.updategrid();
                    setShowErrors(false);
                    props.onHide();
                }
            }).catch((response) => {
            })
        }
    }
    return (
        <Modal
            {...props}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {recommendationModel.modalType} a Recommendation
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form model={model} id="recommendationForm" formValue={recommendationModel} onChange={recommendationModel => setRecommendationModel(recommendationModel)} onSubmit={submitData} fluid>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        First Name&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control name="firstName" />
                            </Col>
                            <Form.HelpText className="d-none">First Name</Form.HelpText>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Last Name&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control name="lastName" />
                            </Col>
                            <Form.HelpText className="d-none">Last Name</Form.HelpText>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Email&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control name="email" />
                            </Col>
                            <Form.HelpText className="d-none">Email</Form.HelpText>
                        </Row>
                    </Form.Group>
                </Form>
                <br />
            </Modal.Body>
            <Modal.Footer>
                <Button type="submit" form="recommendationForm" variant="success">Save</Button>
                <Button onClick={() => { setShowErrors(false); props.onHide(); }}>Cancel</Button>
            </Modal.Footer>
        </Modal >
    );
}

export default AddEditRecommendationModal;